import UploadDocumentsSelfcare from "../../Components/LightWeightCustomer/Documents";

export default function SelfcareDocumentupload(){
    return(
        <UploadDocumentsSelfcare/>
    )
}